import { createContext, useContext, useEffect, useState } from "react";
import { temaDesdeUsuario } from "@/lib/tema";
import { api } from "@/lib/api";
import { safeLS } from "@/lib/safeStorage";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = logged in

  useEffect(() => {
    api
      .get("/auth/me")
      .then((res) => { setUser(res.data); temaDesdeUsuario(res.data); })
      .catch(() => setUser(false));
  }, []);

  const login = (data) => {
    if (data.token) safeLS.setItem("tm_token", data.token);
    else safeLS.removeItem("tm_token");   // portal: sesión solo por cookie httpOnly
    setUser(data.user);
    // el login trae pocos datos: se vuelve a pedir el perfil completo (permisos y secciones visibles)
    api.get("/auth/me").then((res) => { setUser(res.data); temaDesdeUsuario(res.data); }).catch(() => {});
  };

  const refrescar = () => api.get("/auth/me").then((res) => { setUser(res.data); temaDesdeUsuario(res.data); return res.data; }).catch(() => null);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore
    }
    safeLS.removeItem("tm_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, refrescar }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
